var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isOffline)?_c('div',{staticClass:"box",on:{"click":function($event){return _vm.$router.push(_vm.link)}}},[_c('div',{staticClass:"label",class:{
            'icon-default': _vm.type !== 1
        },style:({
            '--dynamic-bg-image': ("url(" + (_vm.type !== -1 ? ("" + _vm.cssImage + (_vm.details.params[_vm.type].value)) : '') + ")")
        })},[_vm._v(" "+_vm._s(_vm.$t(("widget." + (_vm.details.id))).toUpperCase())+" ")])]):_c('div',{staticClass:"box no_wifi"})}
var staticRenderFns = []

export { render, staticRenderFns }